<script setup>
import { handleAnchorClick } from "@/utils/scrollToAnchor";
const props = defineProps({
  open: Boolean,
})
const emit = defineEmits(["close"]);

const handleClick = (link) => {
  handleAnchorClick(link);
  emit("close", true);
  document.body.style.overflow = "";
}
</script>

<template>
  <div class="menu" :class="open ? 'open' : ''">
    <div class="menu__content flex flex-col justify-center relative">
      <a href="#who-we-are" @click="handleClick('#who-we-are')">Who We Are</a>
      <a href="#what-we-do" @click="handleClick('#what-we-do')">What We Do</a>
      <a href="#why-choose-galazia" @click="handleClick('#why-choose-galazia')">Why Choose Galazia</a>
      <a href="#partners" @click="handleClick('#partners')">Partners</a>
    </div>
    <div class="circle-pink absolute"></div>
    <div class="circle-blue absolute"></div>
    <img src="../../assets/main.png" alt="section image" class="absolute"/>
  </div>
</template>

<style scoped lang="scss">
.menu {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  transform: translateY(-100%);
  transition: transform 0.5s ease;
  background: #000;
  overflow: hidden;
  padding: 8.333vw;
  &.open {
    transform: translateY(0);
  }
  &__content {
    gap: clamp(20px, 1.389vw, 100px);
    height: 100%;
    z-index: 2;
    a {
      font-size: clamp(45px, 3.125vw, 225px);
      font-weight: 400;
      line-height: 168.889%;
      text-transform: uppercase;
      text-decoration: none;
      width: fit-content;
      transition: color .3s ease;
      &:hover {
        color: #16ADFC;
      }
    }
  }
  & > img {
    width: 30%;
    top: 30%;
    right: 10%;
    transform: scaleY(-1) scaleX(-1);
  }
  .circle-pink {
    bottom: -3%;
    left: 50%;
    transform: rotate(0);
  }
  .circle-blue {
    top: -5%;
    left: 55%;
    transform: rotate(0);
  }
}

@media (max-width: 768px) {
  .menu {
    padding: 90px 24px 20px;
    &__content {
      gap: 0;
      justify-content: flex-start;
      margin: 60px 0 40px;
      a {
        font-size: 30px;
        line-height: 76px;
      }
    }
    & > img {
      max-width: 280px;
      width: 70%;
      transform: scaleX(-1);
      top: auto;
      bottom: 0;
      right: 20%;
    }
    .circle-blue {
      width: 300px;
      height: 300px;
      top: auto;
      bottom: 0;
      left: auto;
      right: -5%;
    }
    .circle-pink {
      background: #322DB5;
      width: 555px;
      height: 555px;
      left: -20%;
      bottom: -50%;
    }
  }
}
</style>